// @ts-nocheck
import React, { useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import ArrowRightIcon from '@material-ui/icons/ArrowForwardIos'
import Grid from '@material-ui/core/Grid'
import TypographyPro from 'themes/TypographyPro'
import { respondAbove } from 'styles/mixins'
import { getTranslatedTextByKey } from 'utils/utils'
import { FeatureFlagEnum } from 'types/constants.types'
import { useRouter } from 'next/router'
import { ACCOUNT_TAB } from 'utils/constants'
import { useStores } from 'hooks/useStores'

const AccountContainer = styled.div`
	padding: 0 50px 0 40px;
	width: 100%;
	max-width: 350px;
`

const WelcomeTitle = styled(TypographyPro)`
	color: var(--brandTitle);
	margin-block-end: 30px;
	padding-inline: 10px;
	text-transform: uppercase;
`

const OptionText = styled(Grid)`
	position: relative;
	border-bottom: ${({ $isCurrentActive }) => ($isCurrentActive ? '0' : '1px solid var(--optionalBackground)}')};

	&:last-child {
		border-bottom: ${({ $isCurrentActive }) => !$isCurrentActive && 0};
	}

	border: ${({ $isCurrentActive }) => $isCurrentActive && '1px solid var(--brandTitle)'};
	border-radius: ${({ $isCurrentActive }) => $isCurrentActive && 'var(--borderRadiusInput)'};

	&:hover {
		font-weight: bold;
		cursor: pointer;
	}
`

const Name = styled(TypographyPro)`
	padding: 10px;
`

const StyledArrowRightIcon = styled(ArrowRightIcon)`
	color: var(--disable);
	font-size: 15px;
	${respondAbove.lg`
		display: none
	`}
`

const accountMenu = [
	{
		id: 1,
		name: 'accountSettings',
		displayName: () => getTranslatedTextByKey('eCommerce.accountSettings.accountSettings', 'Account Settings'),
		arrowIcon: <StyledArrowRightIcon />,
		testId: 'account-settings-link',
	},
	{
		id: 2,
		name: 'pastOrders',
		displayName: () => getTranslatedTextByKey('eCommerce.accountSettings.pastOrders', 'Past Orders'),
		arrowIcon: <StyledArrowRightIcon />,
		testId: 'account-past-orders-link',
	},
	{
		id: 3,
		name: 'paymentMethods',
		displayName: () => getTranslatedTextByKey('eCommerce.accountSettings.savedPaymentMethods.paymentMethods', 'Payment Methods'),
		arrowIcon: <StyledArrowRightIcon />,
		testId: 'account-payment-method-link',
	}
]

const savedAddressesMenu = 	{
	id: 4,
	name: 'savedAddresses',
	displayName: () => getTranslatedTextByKey('webviewFlow.localization.savedAddresses', 'Saved addresses'),
	arrowIcon: <StyledArrowRightIcon />,
	testId: 'account-saved-addresses',
}

const authenticatorMenu = {
	id: 5,
	name: 'authenticator',
	displayName: () => getTranslatedTextByKey('eCommerce.accountSettings.authenticator', 'Kiosk connection code'),
	arrowIcon: <StyledArrowRightIcon />,
	testId: 'account-authenticator',
}

export const AccountMenu = inject(
	'Account',
	'Infra'
)(
	observer(({ Account, Infra, setCurrentScreen, currentScreen }) => {
		const router = useRouter()
		const { addressManagerV2Store } = useStores()

		const onChangeScreen = useCallback((screenName) => {
			setCurrentScreen(screenName)
			router.push({
				pathname: '/account',
				query: { [ACCOUNT_TAB]: screenName },
			})
		}, [])

		// Check the feature flag to display the saved addresses menu
		if (
			addressManagerV2Store.newLocalizationFlowEnabled &&
			addressManagerV2Store.savedAddressesEnabled &&
			!accountMenu.includes(savedAddressesMenu)
		) {
			accountMenu.push(savedAddressesMenu)
		}

		// Check the feature flag to display the authenticator menu
		if (Infra?.hasFeatureFlag(FeatureFlagEnum.AUTHENTICATOR) && !accountMenu.includes(authenticatorMenu)) {
			accountMenu.push(authenticatorMenu)
		}

		return (
			<AccountContainer>
				<WelcomeTitle variant="h2">
					{getTranslatedTextByKey('hi')},&nbsp;{Account.userName?.split(' ')[0]}!
				</WelcomeTitle>

				<Grid container>
					{accountMenu.map((item) => (
						<OptionText
							item
							key={item.id}
							xs={12}
							container
							justifyContent="space-between"
							alignItems="center"
							onClick={() => onChangeScreen(item.name, '')}
							variant="BodyRegular"
							$isCurrentActive={currentScreen === item.name}
							data-testid={item.testId}
						>
							<Name component="div" variant={currentScreen === item.name ? 'BodyRegularHighlighted' : 'BodyRegular'}>
								{item.displayName()}
							</Name>
							<StyledArrowRightIcon />
						</OptionText>
					))}
				</Grid>
			</AccountContainer>
		)
	})
)
